module.exports = __webpack_public_path__ + "img/music-video.3d9032b8.webp";